import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../services/supabase';
import './AdminLogin.css';

const RegisterPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const redirectTo = params.get('redirect') || '/book';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { error } = await supabase.auth.signUp({ email, password });
      if (error) throw error;
      // Save user name in users table if possible (optional, requires public insert access or edge function)
      // You may need to call an API/edge function here to insert the user profile with name
      alert('Registration successful! Please check your email to confirm your account.');
      navigate(redirectTo);
    } catch (err: any) {
      setError(err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page enhanced-auth-bg">
      <form className="login-form enhanced-auth-card" onSubmit={handleSubmit}>
        <h2 className="enhanced-auth-title">Register</h2>
        <div className="enhanced-auth-group">
          <input
            type="text"
            placeholder="Full Name"
            value={name}
            onChange={e => setName(e.target.value)}
            required
            className="enhanced-auth-input"
          />
        </div>
        <div className="enhanced-auth-group">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="enhanced-auth-input"
          />
        </div>
        <div className="enhanced-auth-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            className="enhanced-auth-input"
          />
        </div>
        {error && <div className="enhanced-auth-error">{error}</div>}
        <button type="submit" className="enhanced-auth-btn" disabled={loading}>{loading ? 'Registering...' : 'Register'}</button>
      </form>
    </div>
  );
};

export default RegisterPage;
